import { gql } from '@apollo/client'

export const GET_FUEL_TYPE_BY_ID = gql`
  query getFuelTypeById($input: ID!) {
    data: getFuelTypeById(id: $input) {
      name
      nameTranslations {
        en
        es
      }
      status
    }
  }
`
